"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAITING = exports.SKIPPED = exports.PERMISSION_DENIED = exports.PASSED = exports.NO_DEVICE_FOUND = exports.INITIALIZE_READINESS_CHECK = exports.FAILED = exports.CHECKING = void 0;
var INITIALIZE_READINESS_CHECK = exports.INITIALIZE_READINESS_CHECK = 'initializeReadinessCheck';
var PASSED = exports.PASSED = 'passed';
var FAILED = exports.FAILED = 'failed';
var CHECKING = exports.CHECKING = 'checking';
var WAITING = exports.WAITING = 'waiting';
var PERMISSION_DENIED = exports.PERMISSION_DENIED = 'permission_denied';
var NO_DEVICE_FOUND = exports.NO_DEVICE_FOUND = 'no_device_found';
var SKIPPED = exports.SKIPPED = 'skipped';